import { useEffect, useMemo, useState } from "react";
import { useFilter } from "../../../../hooks/useFilter";
import {
	flattenSelection,
	primaryFarmIdFromSelection,
	selectionToSortedIdsKey,
	useFilterContextV2,
} from "../../../../contexts/FilterContextV2";
import "../styles.css";
import axios from "../../../../services/axios";

export function InfoBatches() {
	const { batchCategory } = useFilter();
	const { selectedFarms, selectedAreas } = useFilterContextV2();

	const farmsKey = useMemo(
		() => selectionToSortedIdsKey(selectedFarms),
		[selectedFarms],
	);
	const areasKey = useMemo(
		() => selectionToSortedIdsKey(selectedAreas),
		[selectedAreas],
	);

	const [adjustments, setAdjustments] = useState(0);
	const [balanceTotal, setBalanceTotal] = useState<number | null>(null);

	useEffect(() => {
		const farmId = primaryFarmIdFromSelection(selectedFarms);
		const areasIds = flattenSelection(selectedAreas)
			.filter(
				(area) =>
					farmId != null &&
					String(area.info?.farm?.id) === String(farmId),
			)
			.map((area) => Number(area.value));

		if (farmId == null) {
			setAdjustments(0);
			return;
		}

		const controller = new AbortController();

		axios
			.get(`/adjustments?farmId=${farmId}&areaIds=${areasIds}`, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				setAdjustments(
					data.reduce(
						(sum: number, adjustment: { balance: number }) =>
							sum + adjustment.balance,
						0,
					),
				);
			})
			.catch((err: { code?: string }) => {
				if (err?.code === "ERR_CANCELED") return;
				console.error(err);
			});

		return () => controller.abort();
	}, [farmsKey, areasKey]);

	useEffect(() => {
		setBalanceTotal(
			batchCategory?.content.reduce(
				(sum, batch) =>
					sum +
					batch.categories.reduce(
						(batchSum, category) => batchSum + category.quantity,
						0,
					),
				0,
			),
		);
	}, [batchCategory]);

	return (
		<section className="dashBoardInfo__container" style={{ marginTop: 30 }}>
			<div className="dashBoardInfoSplited__owner--container">
				<small>Ajuste atual</small>
				<h6
					className={
						adjustments && adjustments <= 0
							? "dashBoardAdjustment__negative"
							: "dashBoardAdjustment__positive"
					}
				>
					{adjustments || 0}
				</h6>
			</div>

			<div className="dashBoardInfo__dark--container">
				<small>Saldo previsto</small>
				<h6>{(balanceTotal || 0) - (adjustments || 0)}</h6>
			</div>
		</section>
	);
}
